import $ from 'jquery'
import jcf from 'jcf'
import 'jquery-ui/ui/widgets/datepicker'

const customFormLabel = window?.drupalSettings?.widgets?.customForm ?? { from: 'From', to: 'to', language: 'gb' }

const initDatepickerCommonOpts = function () {
  $.datepicker.regional.es = {
    monthNames: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
    dayNamesMin: ['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sá'],
  }
  $.datepicker.regional.fr = {
    monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
  }
  $.datepicker.regional.de = {
    monthNames: ['Januar', 'Februar', 'Mars', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'],
    dayNamesMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
  }
  $.datepicker.regional['pt-br'] = {
    monthNames: ['Janeiro', 'Fevereiro', 'Marte', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
    dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
  }
  $.datepicker.regional['it'] = {
    monthNames: ['Gennaio','Febbraio','Marzo','Aprile','Maggio','Giugno','Luglio','Agosto','Settembre','Ottobre','Novembre','Dicembre'],
    dayNamesMin: ['Do','Lu','Ma','Me','Gi','Ve','Sa'],
  }
  $.datepicker.setDefaults($.datepicker.regional[customFormLabel.language])
}

const initDatepicker = function () {
  const field = $(this)
  const datepicker = {
    container: field,
    dateFormat: 'dd-mm-yy',
    dates: [null, null],
    status: null,
    inputs: {
      dates: $(field).children('.date-line'),
    },
  }

  let noMinDate = false;
  if (field.hasClass('faq-date-form') || field.closest('.commuter-offer-form').length) {
    noMinDate = true;
  }

  datepicker.container.datepicker({
    numberOfMonths: 1,
    dateFormat: datepicker.dateFormat,
    minDate: noMinDate ? null : 0,
    maxDate: field.hasClass('faq-date-form') ? 0 : null,
    hideIfNoPrevNext: !!field.hasClass('faq-date-form'),

    beforeShowDay(date) {
      const currentTime = date.getTime()
      const selectedTime = datepicker.dates
      const checkinDate = selectedTime[0] ? new Date(selectedTime[0]) : null
      const checkoutDate = selectedTime[1] ? new Date(selectedTime[1]) : null
      let checkinTimestamp
      let checkoutTimestamp
      let classes = ''

      date.setHours(0)
      date.setMinutes(0)
      date.setSeconds(0)
      date.setMilliseconds(0)

      // Highlight date range
      if ((selectedTime[0] && selectedTime[0] === currentTime) || (selectedTime[1] && (currentTime >= selectedTime[0] && currentTime <= selectedTime[1]))) {
        classes += ' ui-datepicker-highlight'

        // CHECKIN/CHECKOUT CLASSES
        if (checkinDate) {
          checkinDate.setHours(0)
          checkinDate.setMinutes(0)
          checkinDate.setSeconds(0)
          checkinDate.setMilliseconds(0)
          checkinTimestamp = checkinDate.getTime()
        }

        if (checkoutDate) {
          checkoutDate.setHours(0)
          checkoutDate.setMinutes(0)
          checkoutDate.setSeconds(0)
          checkoutDate.setMilliseconds(0)
          checkoutTimestamp = checkoutDate.getTime()
        }

        if (checkinTimestamp && currentTime === checkinTimestamp) {
          classes += ' ui-checkin'
        } else if (checkoutTimestamp && currentTime === checkoutTimestamp) {
          classes += ' ui-checkout'
        }
      }

      // Check for last day of month.
      const dateCopy = new Date(date.getTime())
      dateCopy.setDate(dateCopy.getDate() + 1)
      if (dateCopy.getDate() === 1) {
        classes += ' ui-datepicker-last-day'
      }
      if (date.getDate() === 1) {
        classes += ' ui-datepicker-first-day'
      }

      return [true, classes]
    },
    onSelect(dateText) {
      if (!datepicker.dates[0] || datepicker.dates[1] !== null) {
        // CHOOSE FIRST DATE

        // fill dates array with first chosen date
        datepicker.dates[0] = $.datepicker.parseDate(datepicker.dateFormat, dateText).getTime()
        datepicker.dates[1] = null

        const checkInDate = $.datepicker.parseDate('@', datepicker.dates[0])

        // clear all inputs
        datepicker.inputs.dates.val(`${customFormLabel.from} ${$.datepicker.formatDate(datepicker.dateFormat, checkInDate)}`)
        datepicker.inputs.dates.closest('.form-item').addClass('show-label-container-one')
        datepicker.inputs.dates.closest('.form-item').removeClass('show-label-container')
        // set current datepicker state
        datepicker.status = 'checkin-selected'
      } else {
        // CHOOSE SECOND DATE

        // push second date into dates array
        datepicker.dates[1] = $.datepicker.parseDate(datepicker.dateFormat, dateText).getTime()

        // sort array dates
        datepicker.dates.sort()

        const checkInDate = $.datepicker.parseDate('@', datepicker.dates[0])
        const checkOutDate = $.datepicker.parseDate('@', datepicker.dates[1])

        datepicker.status = 'checkout-selected'
        // fill input fields

        datepicker.inputs.dates.val(`${customFormLabel.from} ${$.datepicker.formatDate(datepicker.dateFormat, checkInDate)} ${customFormLabel.to} ${$.datepicker.formatDate(datepicker.dateFormat, checkOutDate)}`)
        datepicker.inputs.dates.closest('.form-item').addClass('show-label-container')
        datepicker.inputs.dates.closest('.custom-datepicker').removeClass('active')
        datepicker.inputs.dates.closest('.form-item').removeClass('show-label-container-one')

        if (datepicker.dates[0] === datepicker.dates[1]) {
          datepicker.container.addClass('one-day')
        } else {
          datepicker.container.removeClass('one-day')
        }
      }
    },
  })
}

export const renderCustomElements = (
  form,
) => {
  // Custom select
  let customElements;

  if (!$(form).hasClass('commuter-offer-form')) {
    customElements = $(form).find('select');
  } else {
    customElements = $(form).find('select:not(.custom_select)');
  }

  customElements.each(function () {
    $(this).on('rebuild', function () {
      jcf.refresh($(this))
    })
  })

  jcf.replace(
    customElements,
    'Select', {
      wrapNative: false,
      wrapNativeOnMobile: false,
      fakeDropInBody: false,
      useCustomScroll: true,
      multipleCompactStyle: true,
    },
  )

  jcf.replace('.form-checkbox', 'Checkbox', {})

  jcf.replace('.form-radio', 'Radio', { wrapNative: false })

  function visibility() {
    const holder = $(this).parents('.form-item')

    if ($(this).val() !== '' || holder.hasClass('form-item--error')) {
      holder.addClass('show-label-container')
    } else {
      holder.removeClass('show-label-container')
    }
  }

  $(form).find('input[type=text], input[type=number], input[type=email], textarea').each(visibility)
  $(form).find('select').each(function () {
    if (!$(this).hasClass('with-all')) {
      visibility()
    }
  })
  $(form).find('input[type=text], input[type=number], input[type=email], textarea').on('keyup', visibility)
  customElements.on('change', visibility)

  // Datepicker
  initDatepickerCommonOpts()
  $('.custom-datepicker').each(initDatepicker)


  // Hide/show datepicker
  $('body').on("mousedown touchstart", ".date-line", function(e){
    $(this).closest('.custom-datepicker').addClass('active')
  });


  $('body').on('mouseup touchstart', (e) => {
    const hideClass = $(form).find('.custom-datepicker')
    if (!hideClass.is(e.target)
      && hideClass.has(e.target).length === 0) {
      $(form).find('.custom-datepicker').removeClass('active')
    }
  });

  //textarea count symbols
  $('.form-textarea-wrapper').each(function () {
    const wrapper = $(this)
    const textarea = wrapper.find('textarea')
    const maxlength = textarea.attr('maxlength')
    const max = wrapper.find('.max')

    if (maxlength) {
      max.text(maxlength)
    } else {
      wrapper.find('.text-counter').css('display', 'none')
    }

    textarea.on("input", function() {
      const count = wrapper.find('.type')
      const currentval = $(this).val()
      const currentLength = currentval.length

      if (currentLength <= maxlength) {
        count.text(currentLength)
      } else {
        $(this).val($(this).val().substr(0, maxlength))
      }
    });
  })

}

